import * as Yup from "yup";
const phoneRegExp = /^\+?[0-9]{1,3}?[0-9]{4,14}$/;
const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/;
export const signUp = Yup.object().shape({
  user_first_name: Yup.string()
    .required("First name field is required")
    .label("First Name"),
  user_last_name: Yup.string()
    .required("Last name field is required")
    .label("Last Name"),
  user_email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email field is required")
    .label("Email")
    .matches(emailRegex, "Invalid Email, Please enter correct email address"),
  user_password: Yup.string()
    .required("Password field is required")
    .label("Password"),
  confirm_password: Yup.string()
    .required("Confirm Password field is required")
    .oneOf([Yup.ref("user_password"), null], "Passwords must match")
    .label("Confirm Password"),
});

export const SignIn = Yup.object().shape({
  user_email: Yup.string()
    .required("Email field is required")
    .label("Email")
    .matches(emailRegex, "Invalid Email, Please enter correct email address"),
  user_password: Yup.string()
    .required("Password field is required")
    .label("Password"),
});

export const PaymentLogin = Yup.object().shape({
  payee_email: Yup.string()
    .required("Email field is required")
    .label("Email")
    .matches(emailRegex, "Invalid Email, Please enter correct email address"),
  payee_phone: Yup.string().required("Phone field is required").label("Phone"),
  payee_name: Yup.string()
    .required("Username field is required")
    .label("Username"),
});

export const PasswordValid = Yup.object().shape({
  user_email: Yup.string()
    .required("Email field is required")
    .label("Email")
    .matches(emailRegex, "Invalid Email, Please enter correct email address"),
});

export const verifyFacility = Yup.object().shape({
  svcf_verifier_full_name: Yup.string().required(
    "Facility verifier is required"
  ),
  svcf_verifier_notes_txt: Yup.string().required(
    "Facility verifier is required"
  ),
  svcf_verifier_phn_nbr: Yup.string()
    .matches(/^\+?[0-9]+$/, "Invalid mobile number")
    .min(8, "Mobile number must be at most 8 characters") // Set the maximum length
    .required("Mobile number is required"),
  svcf_verifier_address: Yup.string().required("Verifier address is required"),
});

export const newfacility = Yup.object().shape({
  svcf_name: Yup.string().required("Facility Name is required"),
  svcf_type_id: Yup.string()
    .required("Facility Type is required")
    .label("facility"),
  svcf_contact_email: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  svcf_contact_phone_nbr: Yup.string()
    .matches(/^\+?[0-9]+$/, "Invalid mobile number")
    .min(8, "Mobile number must be at most 8 characters") // Set the maximum length
    .required("Mobile number is required"),
  svcf_desc: Yup.string().required("Facility Description is required"),
  //svcf_addr_street1: Yup.string().required("Address Line 1 is required"),
  svcf_iso_cntry_id: Yup.string().required("Country is required"),
  //svcf_addr_state: Yup.string().required("Zip code is required"),
  svcf_iso_city_id: Yup.string().required("City is required"),
  allow_sms: Yup.boolean(),
  allow_whatsapp_sms: Yup.boolean(),
});

//New Doctor
export const newdoctor = Yup.object().shape({
  provider_name: Yup.string().required("Doctors Name is required"),
  iso_cntry_id: Yup.string().required("Country is required"),
  iso_city_id: Yup.string().required("City is required"),
});

export const ChangePasswordSchema = Yup.object().shape({
  user_email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  user_password: Yup.string().required("Current Password is required"),
  user_new_password: Yup.string()
    .min(8, "New Password must be at least 8 characters")
    .required("New Password is required"),
});

export const serviceFormVadidations = Yup.object().shape({
  svc_name: Yup.string().required("Service Title is required"),
  svc_desc: Yup.string().required("Service Description is required"),
  svc_typ_id: Yup.string().required("Service Type is required"),
  svc_cat_id: Yup.string().required("Service Category is required"),
  svc_curr_cde_id: Yup.string().required("Currency is required"),
  svc_provider_cost_amt: Yup.number().required("Service Cost is required"),
});

export const bankforms = Yup.object().shape({
  bank_acct_email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  bank_acct_holder_name: Yup.string().required(
    "Account Holder Name is required"
  ),
  svc_bank_cntry_id: Yup.string().required("Country is required"),
  svc_bank_bank_name: Yup.string().required("Bank Name is required"),
  svc_bank_account: Yup.string().required("Bank Account Number is required"),
});

//temp solution on bank details. this is for the edit modal to work without email
export const bankformsEdit = Yup.object().shape({
  user_email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  bank_acct_holder_name: Yup.string().required(
    "Account Holder Name is required"
  ),
  svc_bank_cntry_id: Yup.string().required("Country is required"),
  svc_bank_bank_name: Yup.string().required("Bank Name is required"),
  svc_bank_account: Yup.string().required("Bank Account Number is required"),
});

//patient profile
export const patientForm = Yup.object().shape({
  user_first_name: Yup.string().required("First Name is required"),
  user_last_name: Yup.string().required("Last Name is required"),

  ethncty_id: Yup.string().required("Ethnicity is required"),
  gender_id: Yup.string().required("Gender is required"),
  addr_street1: Yup.string().required("Address Line 1 is required"),
  country: Yup.string().required("Country is required"),
  city: Yup.string().required("City is required"),
  user_phone_nbr: Yup.string()
    .required("Phone Number is required")
    .matches(phoneRegExp, "Invalid mobile number")
    .min(8, "Mobile number must be at most 8 characters"),
});
//user profile
export const profileform = Yup.object().shape({
  user_first_name: Yup.string().required("First Name is required"),
  user_last_name: Yup.string().required("Last Name is required"),
  user_phone_nbr: Yup.string()
    .required("Phone Number is required")
    .matches(phoneRegExp, "Invalid mobile number")
    .min(8, "Mobile number must be at most 8 characters"),
  addr_street1: Yup.string().required("Address Line 1 is required"),
  country: Yup.string().required("Country is required"),
  city: Yup.string().required("City is required"),
});
